import { render, staticRenderFns } from "./promotionActivitiesList.vue?vue&type=template&id=2ea07b85&"
import script from "./promotionActivitiesList.vue?vue&type=script&lang=js&"
export * from "./promotionActivitiesList.vue?vue&type=script&lang=js&"
import style0 from "./promotionActivitiesList.vue?vue&type=style&index=0&id=2ea07b85&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea07b85')) {
      api.createRecord('2ea07b85', component.options)
    } else {
      api.reload('2ea07b85', component.options)
    }
    module.hot.accept("./promotionActivitiesList.vue?vue&type=template&id=2ea07b85&", function () {
      api.rerender('2ea07b85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/promotionActivitiesList.vue"
export default component.exports